import type { ReactNode } from "react";
import { cn } from "@/lib/utils";

export function Kbd({ children, className }: { children: ReactNode; className?: string }) {
  return (
    <kbd
      data-slot="kbd"
      className={cn(
        "inline-flex h-6 min-w-6 items-center justify-center rounded-md border border-line bg-surface-muted px-1.5 font-body text-xs text-secondary tabular-nums",
        className,
      )}
    >
      {children}
    </kbd>
  );
}

/** A key sequence such as ["⌘", "K"]. Screen readers hear the label. */
export function Shortcut({ keys, label, className }: { keys: string[]; label?: string; className?: string }) {
  return (
    <span data-slot="shortcut" className={cn("inline-flex items-center gap-1", className)}>
      {label ? <span className="sr-only">{label}</span> : null}
      <span aria-hidden={label ? true : undefined} className="inline-flex items-center gap-1">
        {keys.map((key) => (
          <Kbd key={key}>{key}</Kbd>
        ))}
      </span>
    </span>
  );
}
